<div class="lilate-info-wrap">
    <div class="info-header">
        <div class="lilate-logo"></div>
        <div class="basic-info">
            <div class="exam-date" translate
                [translateParams]="{ lilateDate: lilate.start | amLocale: 'en' | amDateFormat:'ddd DD MMM, HH:mm' }">
                teacher.component-lilate.exam-date
            </div>
            <div class="examinee-info">
                <div class="examinee-name" *ngIf="lilate.student && lilate.student.user">
                    {{lilate.student.user.first_name}}
                    {{lilate.student.user.last_name}}
                </div>
                <!-- <div class="id-icon" (click)="showIdentity()"></div> -->
                <div class="target-level" *ngIf="lilate.targeted_level" translate
                    [translateParams]="{targetLevel: lilate.targeted_level}">
                    teacher.component-lilate.target-level
                </div>

                <div class="examinee-name" *ngIf="lilate.notes_to_teachers">
                    <span translate>teacher.component-lilate.teacher-notes</span> {{lilate.notes_to_teachers}}
                </div>
            </div>
            <div *ngIf="variant">
                <button (click)="joinPreview()" class="preview-btn">
                    <i class="material-icons cursor-pointer">remove_red_eye</i>
                    <span translate>teacher.component-lilate.exam-preview</span>
                </button>
            </div>
        </div>
    </div>
    <div class="lilate-actions-wrap" *ngIf="assessment">
        <!--<div class="lilate-actions-wrap" *ngIf="lilate.provider_link && linkIsValid()">-->
        <!--<button class="join-class-btn" *ngIf="lilate.provider_link && linkIsValid()" (click)="joinClass()" [disabled]="!linkIsValid()">-->
        <button class="join-class-btn" (click)="joinClass()" [disabled]="!linkIsValid()">
            <span translate>teacher.component-lilate.join-class-btn</span>
        </button>
        <button class="open-assessment-btn" *ngIf="assessment" (click)="openAssessment()">
            <span translate>teacher.component-lilate.open-assessment-btn</span>
        </button>
    </div>
    <button class="cancel-btn" *ngIf="cancel" (click)="showModalCancel()"
        translate>teacher.component-lilate.cancel-btn</button>
</div>
<app-modal [componentToLoad]="componentToLoad" [componentName]="componentName" [modalParams]="modalParams"></app-modal>